<template>
  <div v-if="showHotelequia && hotelequiaURL.length > 0" id="chat-bot" class="chat-window" style="bottom: 200px !important;"></div>
</template>
<script>
  import { mapState } from 'vuex'
  import utils from '@/services/utils'
  import api from '@/services/api'
  export default {
    data () {
      return {
	      showHotelequia: false,
	      hotelequiaURL: '',
	      hotelequiaBase: '',
      }
    },
    computed: {
      ...mapState('app', ['locale']),
    },
    watch: {
      locale () {
        this.getData()
      },
    },
    mounted () {
      const enterpriseIDDomain = this.$store.state.app.enterpriseID ? this.$store.state.app.enterpriseID : utils.getDomain()
      api.getItem('utils', false, `hotelequia/${enterpriseIDDomain}`)
        .then(response => {
          this.hotelequiaBase = response.HotelequiaURL
          this.showHotelequia = response.Hotelequia === 1
          this.getData()
        })
    },
    methods: {
      getData () {
        if (this.hotelequiaBase && this.hotelequiaBase.indexOf('?locale') < 0) this.hotelequiaURL = `${this.hotelequiaBase}?locale=${this.locale}` 
        else this.hotelequiaURL = this.hotelequiaBase
        let script = document.createElement('script')
        script.setAttribute('src', this.hotelequiaURL) 
        script.setAttribute('id', 'chatBot') 

        document.head.appendChild(script)
      }
    }
  }
</script>
<style>
.minimizable-web-chat > button.maximize {
  bottom: 80px !important;
  right: 15px !important;
}
</style>

